import BridgeError from './bridge-error';

interface PageErrorMessageJson {
  page_id: string;
  meta?: Record<string, string>;
  error_code: string;
  error_message: string;
}

export default class PageError extends BridgeError {
  readonly id: string;

  readonly meta: Record<string, string> | undefined;

  constructor(id: string, meta: Record<string, string> | undefined, code: string, message: string) {
    super(code, message);
    this.id = id;
    this.meta = meta;
  }

  public toJson(): PageErrorMessageJson {
    return {
      page_id: this.id,
      meta: this.meta,
      error_code: this.code,
      error_message: this.message,
    };
  }

  public static isPageError(data: Record<string, any>): boolean {
    return !!data.page_id && data.error_code !== undefined;
  }

  public static from(data: Record<string, any>): PageError | undefined {
    if (this.isPageError(data)) {
      const request = data as PageErrorMessageJson;
      return new PageError(
        request.page_id,
        request.meta,
        request.error_code,
        request.error_message,
      );
    }
    return undefined;
  }
}

export const DefaultPageErrors = {
  UNKNOWN_PAGE_ID: (id: string, meta?: Record<string, string>): PageError => {
    return new PageError(id, meta, 'unknown_page_id', 'The specified page id was not found');
  },
};
